<!-- 
  * @Author: zql
  * @Date: 2025/1/22 10:42
 -->

<template>
    <div class="content-box" v-loading="loading">
        <p class="m20" v-if="tableData.length<=0&&!loading">历史数据，不支持查看</p>
        
       <template v-else>
        <el-form
            :inline="true"
            :model="formData"
            ref="formData"
            size="mini"
        >
            <el-form-item  prop="dimension_config">
                <custom-input label="筛选"  @append-click=" handleGenAppendClick('dimension_config', { type: '1' })">
                    <ESelect
                        v-model="formData.dimension_config"
                        filterable
                        clearable
                        placeholder="请输入筛选内容关键词"
                        multiple
                        collapse-tags
                        remote
                        reserve-keyword
                        :loading="searchLoading"
                        ref="dimension_config"
                        @visible-change="(val)=>handleVisibleChange(val, 'dimension_config')"
                        :remote-method="(search) => appEntrySearchList(search, 'dimension_config', { type: '1' })"
                    >
                        <p class="option-select">
                            <el-button type="text" @click="()=>handleSelectAll(dimension_config_data, 'dimension_config', 'all')">全选</el-button>
                            <el-button type="text" @click="()=>handleSelectAll(dimension_config_data, 'dimension_config', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option
                            v-for="item in dimension_config_data"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </ESelect>
                    <template #append>
                        <i class="el-icon-document-copy"/>
                    </template>
                </custom-input>
            </el-form-item>
            <el-form-item  prop="dimension">
                <custom-input label="目标维度" @append-click=" handleGenAppendClick('dimension', { type: '2' })">
                    <ESelect
                        v-model="formData.dimension"
                        filterable
                        clearable
                        placeholder="请输入目标维度内容关键词"
                        multiple
                        collapse-tags
                        remote
                        reserve-keyword
                        :loading="searchLoading"
                        ref="dimension"
                        @visible-change="(val)=>handleVisibleChange(val, 'dimension')"
                        :remote-method="(search) => appEntrySearchList(search, 'dimension', { type: '2' })"
                    >
                        <p class="option-select">
                            <el-button type="text" @click="()=>handleSelectAll(dimension_data, 'dimension', 'all')">全选</el-button>
                            <el-button type="text" @click="()=>handleSelectAll(dimension_data, 'dimension', 'cancel')">取消全选</el-button>
                        </p>
                        <el-option
                            v-for="item in dimension_data"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </ESelect>
                    <template #append>
                        <i class="el-icon-document-copy"/>
                    </template>
                </custom-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getDataList" :loading="loading">查询</el-button>
                <el-button @click="exportData" :loading="exportLoading">导出</el-button>
            </el-form-item>
        </el-form>
        <el-table  :data="tableData" style="width: 100%" stripe
                  :header-cell-style="{ background: '#e8eaec', color: '#333' }" size="mini" height="60vh"
                  v-loading="loading" tooltip-effect="dark">
            <el-table-column :label="'筛选：'+(dimensionConfigText||data.dimension_config)" prop="name">
                <template v-slot="scope">
                    <div style="min-width: 250px;max-width: 350px;"><span>{{scope.row.dimension_config_data}}</span></div>
                </template>
            </el-table-column>
            <el-table-column :label="'目标维度：'+(dimensionText||data.dimension)" prop="name">
                <template v-slot="scope">
                    <div style="min-width: 250px;max-width: 350px;"><span>{{scope.row.name}}</span></div>
                </template>
            </el-table-column>
            <el-table-column label="是否触发" width="70" align="center" prop="is_trigger">
                <template v-slot="scope">
                    <span v-if="scope.row.is_trigger=='1'">是</span>
                    <span v-else class="text-color-error">否</span>
                </template>
            </el-table-column>
            <el-table-column label="未触发原因" min-width="150" prop="err_msg">
                <template v-slot="scope">
                    <!--<span>{{ scope.row.err_msg }}</span>-->
                    <div v-html="scope.row.err_msg"></div>
                </template>
            </el-table-column>
        </el-table>
       </template>
        <div class="tar pt20 pr20">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="currentPage" :page-sizes="[100, 200, 300]" :page-size="pageSize"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import API from '@/api/intelligent/intelligentManaged/index.js';
    import {batchSelectModal} from "@/components/modal"
    export default {
        name: "RunRecordDetailModal",
        props:{
            platId:[String,Number],
            runRecordId:[String,Number],
            data:Object,
        },
        data(){
            return {
                tableData: [],
                loading: false,  // 表格loading
                currentPage: 1,
                pageSize: 100,
                total: 0,
                dimensionText:'',
                dimensionConfigText:'',
                formData: {  },
                dimension_config_data: [],
                dimension_data: [],
                searchLoading: false, // 下拉检索loading
                exportLoading: false, // 导出loading
            }
        },
        mounted() {
            this.getDataList();
        },
        methods:{
            async exportData() {
                if(!this.platId||!this.runRecordId) return this.$message.error('数据有误，请求失败');
                this.exportLoading = true;
                let params = {
                    plat_id: this.platId,
                    run_record_id: this.runRecordId,
                    dimension_config: this.formData.dimension_config,
                    dimension: this.formData.dimension,
                    export: '1',
                };
                try {
                    const result = await API.getRunRecordDetail(params);
                    this.$message.success(result.info)
                } catch (error) {
                    this.$message.error(error.info);
                }finally {
                    this.exportLoading = false;
                }
            },
            getDataList(){
                if(!this.platId||!this.runRecordId) return this.$message.error('数据有误，请求失败');
                this.loading = true;
                
                API.getRunRecordDetail({
                    plat_id:this.platId,
                    run_record_id:this.runRecordId,
                    dimension_config:this.formData.dimension_config,
                    dimension:this.formData.dimension,
                    pn:this.currentPage,
                    rn:this.pageSize,
                }).then(res=>{
                    let resData = res.data||{};
                    this.tableData= resData.list||[];
                    this.total = resData.totalCnt||0;

                    this.dimensionText = resData.dimension||'';
                    this.dimensionConfigText = resData.dimension_config||'';


                    this.loading = false;
                }, err => {
                    this.$message.error(err.info);
                    this.loading = false;
                    this.total = 0;
                })
            },
            // 每页条数
            handleSizeChange(val) {
                this.pageSize = val
                this.getDataList()
            },
            // 当前页数
            handleCurrentChange(val) {
                this.currentPage = val
                this.getDataList()
            },
             // 下拉检索
            async appEntrySearchList(search, type, p ={}, cb) {
                try {
                    const params = {
                        plat_id: this.platId,
                        run_record_id: this.runRecordId,
                        search,
                        ...p
                    };
                    this.searchLoading = true
                    const { data } = await API.getSearchDetail(params);
                    const list = data.list;
                    const errList = data.err_list;
                    if (params.batch_search) {
                        cb(errList, ()=> {
                            const ids = list.map(v=>v.id)
                            this[`${type}_data`] = [
                                ...this[`${type}_data`].filter(v=>this.formData[type].includes(v.value)&&!ids.includes(v.value)),
                                ...list.map(v=> {
                                    return {
                                        ...v,
                                        value: v.id,
                                        label: v.name
                                    }
                                })
                            ]
                            this.formData[type] = [...new Set([ ...this.formData[type], ...ids ])];
                        })
                    }else {
                        this[`${type}_data`]= list.map(v=> {
                            return {
                                ...v,
                                value: v.id,
                                label: v.name
                            }
                        })
                    }
                } catch (error) {
                    this.$message.warning(error.info)
                } finally {
                    this.searchLoading = false
                }
            },

            handleGenAppendClick(type, p = {}) {
                const onSubmit = (data, callback)=> {
                    this.appEntrySearchList(
                        '',
                        type,
                        {
                            batch_search: data,
                            ...p
                        },
                        (errs, cb)=> {
                            callback();
                            if (errs.length) {
                                delErrList({
                                    tip: '未找到以下数据信息，请核实，是否需要剔除未找到的?',
                                    list: errs,
                                    onOk: ()=> {
                                        cb();
                                        vm.close();
                                    }
                                })
                            }else {
                                cb();
                                vm.close();
                            }
                        }
                    )
                }
                const { vm, delErrList } = batchSelectModal({
                    title: '批量添加',
                    props: {
                        tip: '输入或粘贴名称或ID，每行一个',
                        hasLoading: true
                    },
                    cbs: {
                        onSubmit
                    }
                })
            },
            handleVisibleChange(visible, type) {
                if (visible) {
                    const options = this.$refs[type].selected|| [];
                    const listData = options.map(v=> {
                        return v.$options.propsData
                    });
                    this.$set(this, `${type}_data`, listData)
                }
            },
            handleSelectAll(list, type, selectType) {
                if(selectType === 'all') {
                    const data = [...(this.formData[type] || [])];
                    data.push(...list.map(v=>v.value));
                    // 去重 赋值
                    this.formData[type] = [ ...new Set(data)]
                }else{
                    let optionList_ids = this[`${type}_data`].map(item=>item.value)
                    let channel_ids = this.formData[type].filter(item=> !optionList_ids.includes(item))
                    this.formData[type] = [...channel_ids]
                }
            },
        },
    }
</script>

<style scoped>

</style>
